import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "floating-btn-panel" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "collapsible" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                id: "pin",
                class: "pin",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.toggle && _ctx.toggle(...args)))
            }, [
                _createElementVNode("i", {
                    class: _normalizeClass(['fa fa-lg', _ctx.visible ? 'fa-angle-double-right' : 'fa-angle-double-left'])
                }, null, 2 /* CLASS */)
            ]),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.visible]
            ])
        ])
    ]));
}
